import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Wir verwenden Cookies',
    description:
      'Wir verwenden Cookies und ähnliche Technologien, um dieses Angebot bereitzustellen. Unbedingt erforderliche Cookies sind immer aktiv.',
    allow_label: 'Alle Cookies akzeptieren',
    reject_label: 'Nur unbedingt erforderliche',
    settings_label: 'Cookie-Einstellungen',
    policy_link_label: 'Datenschutz- und Cookie-Richtlinie',
    categories_label: 'Kategorien',
    always_on_label: 'Immer aktiv',
    required_label: 'Erforderlich',
    save_preferences_label: 'Einstellungen speichern',
    close_label: 'Schließen',
    allow_all_optional_categories_label: 'Alle optionalen Kategorien zulassen',
    save_error: 'Ihre Datenschutzeinstellung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.'
  },
  categories: {
    strictly_necessary: {
      name: 'Unbedingt erforderlich',
      purpose: 'Für dieses Angebot erforderlich und nicht deaktivierbar.'
    },
    analytics: { name: 'Analytik', purpose: 'Misst die Nutzung dieses Angebots, um die Leistung zu verbessern.' },
    marketing: {
      name: 'Marketing',
      purpose: 'Unterstützt vom Veranstalter ausgewählte Werbung und Marketingmaßnahmen.'
    }
  }
};

export default locale;
